export enum WidgetStatusEnum {
  FAILED = 0,
  WARNING,
  PASSED
}
